import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/logistics/packages")({
  component: PackagesLayout,
});

function PackagesLayout() {
  return (
    <RouteGuard module="packages" action="read">
      <Outlet />
    </RouteGuard>
  );
}
